import React, { Fragment, FunctionComponent, useEffect } from 'react';

import { useErrorContext } from 'commons/containers/ValidationErrorManager';
import { useEditor } from 'craft/hooks';
import { ValidationErrorCategory } from 'craft/types';

import FatalErrorModal from './FatalErrorModal';

// eslint-disable-next-line react/prop-types
const ValidationErrorHandler: FunctionComponent = ({ children }) => {
  const { errors, selectedErrorNodeId, setSelectedErrorNodeId } = useErrorContext();
  const { query, actions } = useEditor();

  useEffect(() => {
    if (selectedErrorNodeId) {
      const node = query.node(selectedErrorNodeId).get();
      if (node) {
        node.dom?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        actions.selectNode(selectedErrorNodeId);

        // clear context after selecting node in craft
        setSelectedErrorNodeId(null);
      }
    }
  }, [selectedErrorNodeId]);

  const hasFatalErrors = errors.find(
    ({ category }) => category === ValidationErrorCategory.FatalError,
  );

  return (
    <Fragment>
      {hasFatalErrors && <FatalErrorModal />}
      {children}
    </Fragment>
  );
};

export default ValidationErrorHandler;
